<div class="dialog-container">
  <div *ngIf="data.block" class="dialog-title">
    می‌خواهید {{ data.username }} را بلاک کنید؟
  </div>
  <div *ngIf="!data.block" class="dialog-title">
    می‌خواهید {{ data.username }} را آنبلاک کنید؟
  </div>
  <div *ngIf="data.block" class="dialog-description">
    در صورت بلاک کردن، او پروفایل شما را پیدا نمی‌کند و اطلاعات شما را نمی‌بیند.
  </div>
  <div *ngIf="!data.block" class="dialog-description">
    در صورت آنبلاک کردن، او پروفایل شما را پیدا می‌کند و اطلاعات شما را می‌بیند.
  </div>
  <div *ngIf="data.block" class="dialog-button" (click)="block()">بلاک</div>
  <div *ngIf="!data.block" class="dialog-button" (click)="block()">آنبلاک</div>
  <div class="dialog-button" (click)="cancel()">لغو</div>
</div>
